/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum StickyEntityType {
  Company = "company",
  Shipment = "shipment",
  Carrier = "carrier",
}

export function instanceOfStickyEntityType(value: any): boolean {
  for (const key in StickyEntityType) {
    if (Object.prototype.hasOwnProperty.call(StickyEntityType, key)) {
      if (StickyEntityType[key as keyof typeof StickyEntityType] === value) {
        return true;
      }
    }
  }
  return false;
}

export function StickyEntityTypeFromJSON(json: any): StickyEntityType {
  return StickyEntityTypeFromJSONTyped(json, false);
}

export function StickyEntityTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): StickyEntityType {
  return json as StickyEntityType;
}

export function StickyEntityTypeToJSON(value?: StickyEntityType | null): any {
  return value as any;
}

export function StickyEntityTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): StickyEntityType {
  return value as StickyEntityType;
}
